import { render } from "./PageInclusaoIndicacaoTAF.vue?vue&type=template&id=d4b76df8"
import script from "./PageInclusaoIndicacaoTAF.vue?vue&type=script&lang=js"
export * from "./PageInclusaoIndicacaoTAF.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./PageInclusaoIndicacaoTAF.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__